import { Component } from '@angular/core';
import { SharedLoaderService } from '@app/shared/services/sharedLoader/shared-loader.service';

@Component({
  selector: 'app-global-loader',
  standalone: false,
  templateUrl: './global-loader.component.html',
  styleUrl: './global-loader.component.css'
})
export class GlobalLoaderComponent {
  constructor(private loaderService: SharedLoaderService) { }
  isLoading() {
    return this.loaderService.loading$;
  }
}
